import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { ToastClientService } from "../../../services/toast/toast-client.service";
import { XlsxService } from "src/app/services/xlsx/xlsx.service";
import { ExportExcelService } from "src/app/shared/xlsx-view/export-excel.service";
import { XlsxViewComponent } from "src/app/shared/xlsx-view/xlsx-view.component";
import { ExcelModel } from "../../shared/models/geography";
import { RegionProvider } from "../../shared/providers/region.provider";
import { AdminDataProvider } from "../../shared/providers/master-provider/admin-data.provider";
@Component({
  selector: "app-cities",
  templateUrl: "./cities.component.html",
  styleUrls: ["./cities.component.scss"],
})
export class CitiesComponent implements OnInit {
  addOrEditCity: string;
  cities = [];
  states = [];
  title = "modal2";
  formGroup;
  deletePopupUiData;
  excel: ExcelModel = new ExcelModel();
  tempOptionModel: any;
  filteredDetails: any = {
    search_string:'',
    states: [],
  };
  filteredDetailsForApi:any = {
    search_string:'',
    states: '',
  };
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toast: ToastClientService,
    private xlsx: XlsxService,
    public exportExcelService: ExportExcelService,
    public regionProviders: RegionProvider,
    public adminDataProvider: AdminDataProvider,

  ) {}

  ngOnInit() {
    this.getAllCities();
  }
  // ngDoCheck() {
  //   let states = this.regionProviders.states;
  //   if(states){
  //     this.formateStates(states);
  //   }
  // }
  // formateStates(states){
  //   let filteredStates =  states.filter(ele => ele.id = ele.state_code);
  //   this.states = filteredStates;
  // }
  getAllCities() {
    this.apiService.get(this.apiConfig.configGetCities).subscribe(
      (res: any) => {
        this.cities = res.data.cities;
        this.states = res.data.state_list;
        // console.log(this.cities);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  addCity(targetModal) {
    this.addOrEditCity = "add";

    this.formGroup = this.fb.group({
      cityname: new FormControl("", [
        Validators.required,
        Validators.pattern("[a-zA-Z ]*"),
      ]),
      state_code: new FormControl("", [Validators.required]),
      program_id: 1,
    });

    this.showCityModal(targetModal);
  }

  get f() {
    return this.formGroup.controls;
  }

  editCity(targetModal, cityInfo) {
    this.addOrEditCity = "edit";
    this.formGroup = this.fb.group({
      cityname: new FormControl(cityInfo.cityname, [
        Validators.required,
        Validators.pattern("[a-zA-Z ]*"),
      ]),
      state_code: new FormControl(cityInfo.state_code, [Validators.required]),
      city_id: cityInfo.city_id,
      program_id: 1,
    });

    this.showCityModal(targetModal);
  }

  deleteCity(targetModal, cityInfo) {
    this.addOrEditCity = "delete";
    this.deletePopupUiData = cityInfo.cityname;
    this.formGroup = this.fb.group({
      city_id: cityInfo.id,
      program_id: 1,
    });

    this.showCityModal(targetModal);
  }

  showCityModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  submitted = false;

  onSubmitCity(formData) {
    this.submitted = true;

    if (this.formGroup.invalid) {
      return;
    }

    let apiUrl;
    if (this.addOrEditCity == "add") {
      apiUrl = this.apiConfig.configAddCity;
    } else if (this.addOrEditCity == "edit") {
      apiUrl = this.apiConfig.configEditCity;
    } else if (this.addOrEditCity == "delete") {
      apiUrl = this.apiConfig.configDeleteCity;
    }

    // console.log('API:', apiUrl, formData);

    this.apiService.post(apiUrl, formData).subscribe(
      (res: any) => {
        this.cityActionSuccess();
        this.toast.Success(res.data.message);
      },
      (err) => {
        console.log("err", err);
      }
    );
  }

  cityActionSuccess() {
    this.modalService.dismissAll();
    this.getAllCities();
  }

  /**
   * @auth kailash_dev
   */
  /** Add new brands section */
  showuploadTemplateModal(targetModal) {
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }
  closeoptionModel() {
    this.tempOptionModel.close();
  }
  uploadXlsx(eve) {
    this.xlsx.uploadXlsx(eve).then((res) => {
      this.xlsxView(res);
    });
  }
  xlsxView(data) {
    // data.apiHeaders = this.states;
    this.closeoptionModel();
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        console.log("XlsxViewComponent::", result);
        if (result.length > 0) {
          this.excel.excel_data = result;
          this.importAllUsers(this.excel);
        }
      },
      (reason) => {}
    );
  }

  importAllUsers(data) {
    this.apiService.post(this.apiConfig.importExcelCity, data).subscribe(
      (res: any) => {
        this.toast.Success("Data imported Successfully");
        this.getAllCities();
      },
      (err) => {
        this.toast.Error("Failed to Update");
        console.log(err);
      }
    );
  }

  downloadExcel() {
    this.exportExcelService.exportCityExcel(this.states);
  }
    /* Fillter section start */
    async selectedItem(data, serviceId) {
      switch (serviceId) {
        case 1: // State
          this.filteredDetails.states = await this.formateFillters( data,"states");
        default:
          break;
      }
    }
    formateFillters(data, name) {
      if (data.status == "singleSelect") {
        this.filteredDetails[name].push(data.data.id);
        return this.filteredDetails[name];
      } else if (data.status == "singleDeselect") {
        this.filteredDetails[name].forEach((element, i) => {
          if (element == data.data.id) {
            this.filteredDetails[name].splice(i, 1);
          }
        });
        return this.filteredDetails[name];
      } else if (data.status == "SelectAll") {
        this.filteredDetails[name] = [];
        if (data.data) {
          data.data.forEach((element) => {
            this.filteredDetails[name].push(element.id);
          });
        }
        return this.filteredDetails[name];
      } else if (data.status == "unSelectAll") {
        this.filteredDetails[name] = [];
        return this.filteredDetails[name];
      }
    }
    filterListOfRecords(){
      try {
        this.filteredDetailsForApi.states = [...this.filteredDetails.states].toString();
        this.filteredDetailsForApi.search_string = this.filteredDetails.search_string
      } catch (error) {    }
      console.log(this.filteredDetailsForApi);
      this.getFilteredCities(this.filteredDetailsForApi);
    }
    getFilteredCities(data) {
      console.log(typeof data.search_string);
      this.apiService.get(this.apiConfig.filterByCity+'?cityname='+data.search_string+"&state_id="+data.states).subscribe(
        (res: any) => {
          console.log(res);
          this.cities = res.data;
        },
        (err) => {
          console.log(err);
        }
      );
    }
}
